import type { ReactElement } from 'react';
import { Button } from '../atoms/button';
import { cn } from '../lib/utils';

export interface PaginationProps {
  readonly page: number;
  readonly totalPages: number;
  readonly onPageChange: (page: number) => void;
  readonly className?: string;
}

/** 목록 페이지 이동 내비게이션 — 이전·다음 버튼과 현재 위치 표시. 넘길 쪽이 없으면(0건) 아무것도 그리지 않는다. */
export const Pagination = ({
  page,
  totalPages,
  onPageChange,
  className,
}: PaginationProps): ReactElement | null => {
  if (totalPages < 1) return null;
  return (
    <nav className={cn('flex items-center gap-3', className)} aria-label="페이지 이동">
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        이전
      </Button>
      <span className="text-sm text-muted-foreground">
        {page} / {totalPages}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        다음
      </Button>
    </nav>
  );
};
